import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {FormComponent} from './pages/form/form.component';
import {HomeComponent} from './pages/home/home.component';
import {ServicesComponent} from './pages/allServices/services.component';
import {ServiceDescriptionComponent} from './pages/serviceDescription/serviceDescription.component';
import {CategoryResolver} from './shared/resolvers/category.resolver';
import {PageNotFoundComponent} from './pages/pageNotFound/pageNotFound.component';
import {TermsComponent} from './pages/terms/terms.component';
import {PrivacyComponent} from './pages/privacy/privacy.component';
import {ContactComponent} from './pages/contact/contact.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { DataSafetyPolicyComponent } from './pages/dataSafetyPolicy/dataSafetyPolicy.component';



const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'reg', component: FormComponent},
  {path: 'terms/:id', component: TermsComponent},
  {path: 'terms', component: TermsComponent},
  {path: 'privacy', component: PrivacyComponent},
  {path: 'data-safety-policy', component: DataSafetyPolicyComponent},
  {path: 'privacy/:id', component: PrivacyComponent},
  {path: 'services/:id', component: ServicesComponent},
  {path: 'service-description/:id', component: ServiceDescriptionComponent, resolve: {Info: CategoryResolver}},
  {path: 'contact', component:ContactComponent},
  {path: 'profile/:id', component: ProfileComponent},
  // {path:'service-details/:id', component: ServiceDetailsComponent, resolve: {Info: CategoryResolver}},
  {path:'**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
